import gqlRequest from "graphql/generic";
import { NewPermissionsType } from "v2-types/user";

type updatePermissionsReturn = {
  updatePartyPermissions:{
    _id:string;
    permissions:NewPermissionsType[]
  }
}

type updatePermissionsPams = {
  id:string;
  data: NewPermissionsType[]
}

const updateUserPermissionsQuery = `
    mutation UpdatePartyPermissions($id: ID!, $data: [PartyPermissionContent!]) {
      updatePartyPermissions(_id: $id, data: $data) {
        _id
        permissions {
          kind
          element
        }
      }
    }
`;

export const updateUserPermissions = (params:updatePermissionsPams) => gqlRequest<updatePermissionsReturn, updatePermissionsPams>(updateUserPermissionsQuery, params);